import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { BookGetModel, SlokaTypeModel } from 'src/app/interfaces/interfaces';
import { DashboardLogicService } from 'src/app/logic/dashboard.service';
import { BookLogicService } from 'src/app/logic/book.service';
import { PassDataService } from 'src/app/services/pass-data.service';

@Component({
  selector: 'app-books-list',
  templateUrl: './books-list.component.html',
  styleUrls: ['./books-list.component.scss']
})
export class BooksListComponent implements OnInit {

  booksList$: Observable<BookGetModel[]> = new Observable<
  BookGetModel[]
  >();

  deletBookId: string = '';

  page: number = 1;

  constructor(
    private passDataService: PassDataService,
    private bookLogicService: BookLogicService,
    private dashboardLogicService: DashboardLogicService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.booksList$ = this.passDataService.getAllBooks();
  }

  onAddButtonClick() {
    this.router.navigate(['/page/add-book'], {
      state: { isAdd: true, isEdit: true, isView: false },
    });
  }

  receivedAction(e: any) {
    e.isAddSloka &&
      this.router.navigate(['/page/add-book/'], {
        state: {
          isAddSloka: true,
          isAdd: true,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isEdit &&
      this.router.navigate([`/page/books/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: true,
          isView: false,
          data: e.data,
        },
      });

    e.isView &&
      this.router.navigate([`/page/books/${e.data.title}`], {
        state: {
          isAddSloka: false,
          isAdd: false,
          isEdit: false,
          isView: true,
          data: e.data,
        },
      });

    e.isDelete &&
      this.passDataService.setPopup({
        isPopup: true,
        message: 'Are you sure to delete this book?',
        isOk: false,
        isDelete: true,
        response: '',
      });

    e.isDelete &&
      this.passDataService
        .getPopupAction()
        .pipe(
          filter((a) => {
            return (a != '' || a != null || typeof a != 'undefined');
          }),
          map((b) => b == 'delete'),
          filter((c) => c),
          switchMap(async (d) =>
            await this.bookLogicService.deleteBookLogic(e?.data)
          ),
          take(1)
        )
        .subscribe((v: any) => {
          v.message == 'Book deleted succesfully' &&
            this.dashboardLogicService.getAllSlokaTypesAndSlokas().subscribe() &&
            this.passDataService.setPopup({
              isPopup: true,
              message: 'Book info deleted successfully!',
              isOk: true,
              isDelete: false,
              response: '',
            });
        });
  }

}
